var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "apprach" },
    [
      _vm.items && _vm.items.length
        ? _c(
            "div",
            { staticClass: "row u-top-margin--s-important" },
            _vm._l(_vm.items, function (file, index) {
              return _c(
                "div",
                { key: index, staticClass: "col-default-6 col-mobile-12" },
                [
                  _c(
                    "z-filelist",
                    [
                      _c(
                        "z-filelist-item",
                        {
                          attrs: {
                            icon: "file/" + file.file.type,
                            info: file.file.size,
                          },
                        },
                        [
                          _c(
                            "z-link",
                            { attrs: { href: file.file.link, blank: "" } },
                            [_vm._v(" " + _vm._s(file.name) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.foldersWithFiles && _vm.foldersWithFiles.length
        ? _c("z-tabs", {
            attrs: { kind: "drop", size: "m" },
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function () {
                    return _vm._l(
                      _vm.foldersWithFiles,
                      function (accordion, i) {
                        return _c(
                          "z-tabs-label",
                          { key: i, attrs: { id: "lable" + i } },
                          [_vm._v(_vm._s(accordion.name))]
                        )
                      }
                    )
                  },
                  proxy: true,
                },
                {
                  key: "content",
                  fn: function () {
                    return _vm._l(
                      _vm.foldersWithFiles,
                      function (accordion, i) {
                        return _c(
                          "z-tabs-content",
                          {
                            key: i,
                            staticClass: "row u-top-margin--s-important",
                            attrs: { id: "lable" + i },
                          },
                          _vm._l(accordion.items, function (file, index) {
                            return _c(
                              "z-filelist-item",
                              {
                                key: index,
                                staticClass: "col-default-6 col-mobile-12",
                                attrs: {
                                  icon: "file/" + file.file.type,
                                  info: file.file.size,
                                },
                              },
                              [
                                _c(
                                  "z-link",
                                  {
                                    attrs: { href: file.file.link, blank: "" },
                                  },
                                  [_vm._v(" " + _vm._s(file.name) + " ")]
                                ),
                              ],
                              1
                            )
                          }),
                          1
                        )
                      }
                    )
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3845224010
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }